<template>
  <div style="padding: 0 12px; margin-bottom: 12px">
    <div class="audit-fail-container" @click="toRefundDetail">
      <div class="auto-tag van-hairline--surround">自动退款</div>

      <h4 class="audit-title ml-8">退款金额</h4>

      <p class="refund-price ml-8">¥{{ orderDetail && orderDetail.mainRefundOrderAmount | price }}</p>

      <p class="refund-status">
        {{ orderDetail && refundStatusZhEnum[orderDetail.mainRefundStatus] }}
      </p>

      <van-icon color="#bfbfbf" class="ml-8" name="cap-arrow" />
    </div>
  </div>
</template>
<script>
import { refundStatusZhEnum } from '@/constant';
export default {
  props: {
    orderDetail: {
      type: Object,
      default: () => ({
        mainRefundOrderAmount: 0,
        mainRefundStatus: null
      })
    }
  },
  data() {
    return {
      refundStatusZhEnum
    };
  },
  methods: {
    toRefundDetail() {
      if (!this.orderDetail.mainRefundId) {
        this.$toast('没有退款单号');
        return;
      }
      this.$router.push('/refund/' + this.orderDetail.mainRefundId);
    }
  }
};
</script>
<style lang="less" scoped>
.audit-fail-container {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 16px 12px;
  background: #ffffff;
  border-radius: 12px;
  .ml-8 {
    margin-left: 8px;
  }
  .auto-tag {
    &.van-hairline--surround::after {
      border-radius: 8px;
      border-color: #bfbfbf;
    }
    font: 500 10px/10px PingFangSC-Medium, PingFang SC;
    padding: 2px;
    border-radius: 2px;
    color: #8c8c8c;
  }
  .audit-title {
    color: #262626;
    font-weight: 500;
  }
  .refund-price {
    flex: 1;
    color: #ff4e47;
    font-weight: 500;
  }
  .refund-status {
    color: #ff8200;
    font-weight: 500;
  }
}
</style>